import {NgModule} from '@angular/core';

import {ImageListingModalComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {ImageListModule} from "../../../list/components/image-list/image-list.module";

/**
 * Module for the ImageListingModalModule
 * @class
 */
@NgModule({
  declarations: [ImageListingModalComponent],
  entryComponents: [ImageListingModalComponent],
  exports: [ImageListingModalComponent],
  imports: [
    IonicModule,
    ImageListModule,
  ],
  providers: [],
})
export class ImageListingModalModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/image-listing-modal/image-listing-modal.module.ts